import classNames from 'classnames/bind';
import styles from './PrevNextButtons.module.scss';
import { useCallback, useEffect, useState } from 'react';
import { CircledChevronLeft, CircledChevronRight } from '@/components';

let cx = classNames.bind(styles);

export const usePrevNextButtons = (emblaApi, onButtonClick) => {
	const [prevBtnDisabled, setPrevBtnDisabled] = useState(true);
	const [nextBtnDisabled, setNextBtnDisabled] = useState(true);

	const onPrevButtonClick = useCallback(() => {
		if (!emblaApi) return;
		emblaApi.scrollPrev();
		if (onButtonClick) onButtonClick(emblaApi);
	}, [emblaApi, onButtonClick]);

	const onNextButtonClick = useCallback(() => {
		if (!emblaApi) return;
		emblaApi.scrollNext();
		if (onButtonClick) onButtonClick(emblaApi);
	}, [emblaApi, onButtonClick]);

	const onSelect = useCallback((emblaApi) => {
		setPrevBtnDisabled(!emblaApi.canScrollPrev());
		setNextBtnDisabled(!emblaApi.canScrollNext());
	}, []);

	useEffect(() => {
		if (!emblaApi) return;

		onSelect(emblaApi);
		emblaApi.on('reInit', onSelect).on('select', onSelect);
	}, [emblaApi, onSelect]);

	return {
		prevBtnDisabled,
		nextBtnDisabled,
		onPrevButtonClick,
		onNextButtonClick,
	};
};

export const PrevButton = ({ ...props }) => {
	return (
		<button className={cx(['prev'])} {...props} aria-label='Go to next slide'>
			<CircledChevronLeft />
			<span className={cx('sr-only')}>View previous slide</span>
		</button>
	);
};

export const NextButton = ({ ...props }) => {
	return (
		<button className={cx(['next'])} {...props} aria-label='Go to previous slide'>
			<CircledChevronRight />
			<span className={cx('sr-only')}>View next slide</span>
		</button>
	);
};
